<template>
    <b-row>
        <b-col cols="12">
            <label>{{ $t('nuevo_abono.tus_asientos') }}</label>
        </b-col>
        <b-col cols="12">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row class="lightgray-content p-2 mb-2" v-for="(asiento, index) in asientos" :key="index">
                    <b-col cols="12">
                        <div class="oswald text-bold" style="text-transform: capitalize;">
                            {{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ ++index }}. 
                            <span v-if="asiento.zona_nombre">{{ asiento.zona_nombre }}</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="ml-2">
                            <small v-if="asiento.fila">{{ $t('general.fila') }}: {{ asiento.fila }} /</small> 
                            <small v-if="asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento }}</small>
                        </div>
                    </b-col>
                    <b-col cols="12" v-if="asiento.precios">
                        <multiselect
                            :disabled="false"
                            v-model="asiento.precio_seleccionado"
                            :placeholder="$t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos})"
                            track-by="id"
                            :options="asiento.precios"
                            :allow-empty="false"
                            rules="required"
                            :custom-label="({ name, amount }) => name + ' - ' + $options.filters.formatear_precio(amount)"
                            :preselectFirst="true"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <button 
                            class="button effect-button large-button mb-4 mb-lg-5"  
                            @click.prevent="continuar" 
                            type="submit"
                        >
                            {{ $t('nuevo_abono.continuar_compra') }}
                        </button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        asientos: {
            type: Array,
            required: true
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro
        }
    },
    methods: {
        continuar() {
            this.$emit('continuar', this.asientos);
        }
    },
}
</script>
